export const classes = {
  dialogBody: 'pt-4 pb-12 text-taupe-2 dark:text-mauve-2',
};
